import { ArrowDownOutlined, ArrowUpOutlined, DashOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import classes from './style.module.scss';

const LABELS_WIND_DIR = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

const ActivityChart = ({ cameras, activities, windData, timeIndex }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const activity = activities[timeIndex];
    const data = cameras.map((camera, index) => {
      const activityValue = (!Array.isArray(activity) && {}.hasOwnProperty.call(activity, camera.id)) ? activity[camera.id] : 0;

      const prevActivity = timeIndex > 0 ? activities[timeIndex - 1] : null;
      const prevActivityValue = prevActivity != null ? (!Array.isArray(prevActivity) && {}.hasOwnProperty.call(prevActivity, camera.id)) ? prevActivity[camera.id] : 0 : 0;
      const margin = activityValue - prevActivityValue;

      const windInfo = windData.find((info) => info.id == camera.id);
      let wind;
      if (windInfo) {
        wind = windInfo.weather ? windInfo.weather[Math.floor(timeIndex / 24)].data_hourly[timeIndex % 24] : null;
      }
      const item = {
        camera: camera.name ? camera.name : camera.IMEI,
        activity: activityValue,
        windDir: wind ? LABELS_WIND_DIR.indexOf(wind.wind_dir) * 22.5 : -1,
        windSpeed: wind ? wind.wind_speed : '---',
        marginActivity: margin,
      };
      return item;
    });
    console.log('chart data', data);
    setChartData(data);
  }, [cameras, activities, windData, timeIndex]);

  const columns = [
    {
      title: '', // No header label for camera
      dataIndex: 'camera',
      key: 'camera',
      render: (val) => <strong>{val}</strong>,
    },
    {
      title: '📊',
      dataIndex: 'activity',
      key: 'activity',
      align: 'center' as const,
      render: (val, row, index) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {row.marginActivity > 0 && (
            <ArrowUpOutlined style={{ color: 'green' }} />
          )}
          {row.marginActivity < 0 && (
            <ArrowDownOutlined style={{ color: 'red' }} />
          )}
          {row.marginActivity == 0 && (
            <DashOutlined style={{ color: 'gray' }} />
          )}
          <span style={{ color: row.marginActivity > 0 ? 'green' : 'red', display: row.marginActivity == 0 ? 'none' : 'inherit' }}>
            {row.marginActivity > 0 ? '+' : ''}
            {row.marginActivity}
          </span>
        </div>
      ),
    },
    {
      title: '🧭',
      dataIndex: 'windDir',
      key: 'windDir',
      align: 'center' as const,
      render: (val, row, index) => (
        <>
          {val != -1 ? <ArrowUpOutlined style={{ color: 'blue', transform: `rotate(${row.windDir}deg)` }} /> : <DashOutlined style={{ color: 'gray' }} />}
        </>
      ),
    },
    {
      title: '💨',
      dataIndex: 'windSpeed',
      key: 'windSpeed',
      align: 'center' as const,
      render: (val) => (
        <span>{val} miles/h</span>
      ),
    },
  ];

  const getIcon = (value) => {
    console.log('chart value', value);
  };

  return (
    <div className={classes.camera_table_container}>
      <Table
        columns={columns}
        dataSource={chartData}
        pagination={false}
        bordered={false}
        rowClassName={() => classes.compact_row}
      />
    </div>
  );
};

export default ActivityChart;
